export { HfdTag } from "./pages/hfdTag";
